<template>
    <div class="home">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="对公转账认证" name="first">
                    
                <div class="handle_header">
                    <el-card class="box-card">
                        <div class="search">
                        <el-form :inline="true">
                            <el-form-item label="搜索">
                            <el-input size="mini" v-model="option1.name" placeholder="亿客账户名称"></el-input>
                            <el-input size="mini" v-model="option1.phone" placeholder="手机号"></el-input>
                            </el-form-item>
                            <el-form-item>
                            <el-button size="mini" type="primary" @click="search1">查询</el-button>
                            <el-button size="mini" @click="reset1">重置</el-button>
                            </el-form-item>
                        </el-form>
                        </div>
                    </el-card>
                </div>
                
                <el-button type="primary" size="mini" @click="derive1">导出</el-button>
                <el-table :data="tableData1" border style="width: 100%; margin-top: 10px"
                    :row-style="{ 'font-size': '12px', color: '#324253' }"
                    :header-row-style="{ 'font-size': '12px', color: '#8994A1' }">
                    <el-table-column align="center" prop="name" label="亿客账户名称"></el-table-column>
                    <el-table-column align="center" prop="company_name" label="付款公司名称"></el-table-column>
                    <el-table-column align="center" prop="company_amount" label="付款金额"></el-table-column>
                    <el-table-column align="center" label="手机号">
                        <template slot-scope="scope">
                            <span @click="displayPhone1(scope)">{{ scope.row.real_phone || scope.row.phone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="create_time" label="录入时间"></el-table-column>
                    <el-table-column align="center" prop="image1" label="转账截图">
                        <template slot-scope="scope">
                            <div class="imags">
                                <viewer :images="scope.row.image1.split('|')">
                                    <img :style="{ marginLeft: index == 1 ? '10px' : ''}" class="img" v-for="(src, index) in scope.row.image1.split('|')" :src="src" :key="index">
                                </viewer>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <router-link :to="'/firm/edit1/' + scope.row.id">编辑</router-link>
                            <a style="margin-left: 10px;" href="javascript:;" @click="deleteRow1(scope, scope.row.id)">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    v-show="tableData1.length > 0"
                    style="display: flex;justify-content: flex-end;"
                    background
                    @current-change="handleCurrentChange1"
                    :current-page="option1.pageNum"
                    :page-size="option1.pageSize"
                    :page-sizes="[10]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="法人人脸认证" name="second">
                    
                <div class="handle_header">
                    <el-card class="box-card">
                        <div class="search">
                        <el-form :inline="true">
                            <el-form-item label="搜索">
                            <el-input size="mini" v-model="option2.name" placeholder="亿客账户名称"></el-input>
                            <el-input size="mini" v-model="option2.phone" placeholder="手机号"></el-input>
                            </el-form-item>
                            <el-form-item>
                            <el-button size="mini" type="primary" @click="search2">查询</el-button>
                            <el-button size="mini" @click="reset2">重置</el-button>
                            </el-form-item>
                        </el-form>
                        </div>
                    </el-card>
                </div>
                    
                <el-button type="primary" size="mini" @click="derive2">导出</el-button>
                <el-table :data="tableData2" border style="width: 100%; margin-top: 10px"
                    :row-style="{ 'font-size': '12px', color: '#324253' }"
                    :header-row-style="{ 'font-size': '12px', color: '#8994A1' }">
                    <el-table-column align="center" prop="name" label="亿客账户名称"></el-table-column>
                    <el-table-column align="center" prop="company_name" label="公司名称"></el-table-column>
                    <el-table-column align="center" prop="corporate_name" label="法人姓名"></el-table-column>
                    <el-table-column align="center" prop="id_photo" label="身份证照片">
                        <template slot-scope="scope">
                            <div class="imags">
                                <viewer :images="scope.row.id_photo.split('|')">
                                    <img :style="{ marginLeft: index == 1 ? '10px' : ''}" class="img" v-for="(src, index) in scope.row.id_photo.split('|')" :src="src" :key="index">
                                </viewer>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="手机号">
                        <template slot-scope="scope">
                            <span @click="displayPhone2(scope)">{{ scope.row.real_phone || scope.row.phone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="id_video" label="人脸视频">
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <video class="video" controls>
                                    <source :src="scope.row.id_video" type="video/mp4" />
                                </video>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="create_time" label="录入时间"></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <router-link :to="'/firm/edit2/' + scope.row.id">编辑</router-link>
                            <a style="margin-left: 10px;" href="javascript:;" @click="deleteRow2(scope, scope.row.id)">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    v-show="tableData2.length > 0"
                    style="display: flex;justify-content: flex-end;"
                    background
                    @current-change="handleCurrentChange2"
                    :current-page="option2.pageNum"
                    :page-size="option2.pageSize"
                    :page-sizes="[10]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total2">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import md5 from "js-md5";
import axios from 'axios'
export default {
    name: "userList",
    data() {
        return {
            activeName: 'first',
            total1: 0,
            option1: {
                name: '',
                phone: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData1: [],
            total2: 0,
            option2: {
                name: '',
                phone: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData2: [],
        };
    },
    methods: {
        displayPhone1(scope) {
        if (scope.row.real_phone) {
            return;
        }

        var password = prompt('请输入安全码');
        if (!password) {
            return;
        }

        axios({
            url: 'https://rz.hnbzyl.com/query_mobile',
            method: 'post',
            data: { id: scope.row.id, source: 2, password: password }
        }).then(res => {
            return res.data;
        }).then(res => {
            console.log('查询结果', res);
            if (!res || res.code != 200) {
                alert('查询失败');
                return;
            }
            scope.row.real_phone = res.data;
        }).catch(function(){
            alert('查询失败');
        });
    
        },
        displayPhone2(scope) {
            if (scope.row.real_phone) {
                return;
            }
            var password = prompt('请输入安全码');
            if (!password) {
                return;
            }

            axios({
                url: 'https://rz.hnbzyl.com/query_mobile',
                method: 'post',
                data: { id: scope.row.id, source: 3, password: password }
            }).then(res => {
                return res.data;
            }).then(res => {
                console.log('查询结果', res);
                if (!res || res.code != 200) {
                    alert('查询失败');
                    return;
                }
                scope.row.real_phone = res.data;
            }).catch(function(){
                alert('查询失败');
            });
        
        },
        deleteRow1(scope, id) {
            console.log('删除', id);
            var password = prompt('请输入安全码');
            if (!password) {
                return;
            }
            axios({
                url: 'https://rz.hnbzyl.com/delete_firm1',
                method: 'post',
                data: {
                    id: id,
                    password: password,
                }
            }).then(res => {
                res = res.data;
                console.log('删除结果', res);
                if (!res || res.code != 200) {
                alert(res.msg || '删除失败');
                return;
                }
                this.tableData1.splice(scope.$index, 1);
                alert('删除成功');
            }).catch(function(){
                alert('删除失败');
            });
        },
        deleteRow2(scope, id) {
            console.log('删除', id);
            var password = prompt('请输入安全码');
            if (!password) {
                return;
            }
            axios({
                url: 'https://rz.hnbzyl.com/delete_firm2',
                method: 'post',
                data: {
                    id: id,
                    password: password,
                }
            }).then(res => {
                res = res.data;
                console.log('删除结果', res);
                if (!res || res.code != 200) {
                alert(res.msg || '删除失败');
                return;
                }
                this.tableData2.splice(scope.$index, 1);
                alert('删除成功');
            }).catch(function(){
                alert('删除失败');
            });
        },
        derive1(){
            var password = prompt('请输入安全码');
            if (!password) {
                return;
            }
            axios({
                url: 'https://rz.hnbzyl.com/download_xls',
                method: 'get',
                responseType: "blob",//重要配置
                params: {type: '对公转账认证', password: password,}
            }).then(res => {
                if (res.data.type == 'application/json') {
                    alert('导出失败');
                    return;
                }
                const aLink = document.createElement("a");
                let blob = new Blob([res.data])
                aLink.href = URL.createObjectURL(blob)
                aLink.setAttribute('download', '对公转账认证.xlsx') // 设置下载文件名称
                aLink.click()
            })
        },
        derive2(){
            var password = prompt('请输入安全码');
            if (!password) {
                return;
            }
            axios({
                url: 'https://rz.hnbzyl.com/download_xls',
                method: 'get',
                responseType: "blob",//重要配置
                params: {type: '法人人脸认证', password: password,}
            }).then(res => {
                if (res.data.type == 'application/json') {
                    alert('导出失败');
                    return;
                }
                const aLink = document.createElement("a");
                let blob = new Blob([res.data])
                aLink.href = URL.createObjectURL(blob)
                aLink.setAttribute('download', '法人人脸认证.xlsx') // 设置下载文件名称
                aLink.click()
            })
        },
        handleClick(tab, event) {
            console.log(tab.name, event);
            if(tab['name'] == 'first'){
                this.getList1()
            }else if(tab['name'] == 'second'){
                this.getList2()
            }
        },
        getList1() {
            this.tableData1 = [];
            axios({
                url: `https://rz.hnbzyl.com/list_transfer_authen`,
                method: 'get',
                params: this.option1
            }).then(res => {
                if (res.data.code == 200) {
                    this.tableData1 = res.data.data
                    this.total1 = res.data.total
                }
            })
        },
        getList2() {
            this.tableData2 = [];
            axios({
                url: `https://rz.hnbzyl.com/list_corporate_face`,
                method: 'get',
                params: this.option2
            }).then(res => {
                if (res.data.code == 200) {
                    this.tableData2 = res.data.data
                    this.total2 = res.data.total
                }
            })
        },
        handleCurrentChange1(val, currentPage) {
            this.option1.pageNum = val;
            this.getList1();
        },
        handleCurrentChange2(val, currentPage) {
            this.option2.pageNum = val;
            this.getList2();
        },
        search1() {
            this.getList1();
        },
        reset1() {
            this.option1.name = '';
            this.option1.phone = '';
            this.option1.pageNum = 1;
            this.option1.pageSize = 10;
            this.getList1();
        },
        search2() {
            this.getList2();
        },
        reset2() {
            this.option2.name = '';
            this.option2.phone = '';
            this.option2.pageNum = 1;
            this.option2.pageSize = 10;
            this.getList2();
        },
    },
    activated() {
        this.getList1()
        this.getList2()
    },
};
</script>

<style lang="less" scoped>
.home {
    padding: 20px;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
}

.page {
    text-align: right;
}

.imags {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img {
  width: 80px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #999;
}
.video{
  width: 80px;
  height: 80px;
  // object-fit: contain;
  cursor: pointer;
  border: 1px solid #999;
}
</style>